import { render } from "./MemoryTests.vue?vue&type=template&id=261dbd98"
import script from "./MemoryTests.vue?vue&type=script&lang=js"
export * from "./MemoryTests.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__